/** Display helpers of the simulator pages: whole JOD, percentages and points as the HTML version printed them. */

export const money = (value: number): string => Math.round(value).toLocaleString('en-US');

/** `0.123` → `12%`; with `digits`, `12.3%`. */
export const pct = (value: number, digits = 0): string => {
  const factor = 10 ** digits;

  return `${Math.round(value * 100 * factor) / factor}%`;
};

/** `0.03` → `3`; `0.025` → `2.5`. Points are percentages without the sign. */
export const pts = (value: number): string => (Math.round(value * 1000) / 10).toString().replace(/\.0$/, '');

/** `0.03` → `+3`; `-0.1` → `-10`. */
export const signed = (value: number): string => {
  const rounded = Math.round(value * 1000) / 10;

  return `${rounded > 0 ? '+' : ''}${rounded.toString().replace(/\.0$/, '')}`;
};

/** Saved-at stamps, e.g. `25 Oct 2026, 09:30`. */
export const stamp = (iso: string): string => {
  const date = new Date(iso);

  if (Number.isNaN(date.getTime())) {
    return '—';
  }

  return new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }).format(date);
};

/** A number typed into a field; blank or nonsense counts as zero, like the HTML version. */
export const numberOf = (raw: string): number => {
  const parsed = parseFloat(raw);

  return Number.isFinite(parsed) ? parsed : 0;
};
